module.exports = __webpack_public_path__ + "static/media/Yoyo_3621.ca1066ac.jpg";